import { type SortModel } from "@/lib/depict-client/types/api/ProductListingRequestV3"

export type Action =
    | { type: "SET_FILTER"; payload: { field: string; op: string; data: string[] } }
    | { type: "CLEAR_FILTER"; payload: { field: string; value: string } }
    | { type: "CLEAR_ALL_FILTERS" }
    | { type: "SORT_PRODUCTS"; payload: SortModel }
    | { type: "CLEAR_SORT" }
    | { type: "HYDRATE_FROM_URL"; payload: FilterState }

// Define state type
export type FilterType = {
    field: string
    op: string
    data: string[]
}

export type FilterState = {
    filters: FilterType[]
    sort: SortModel | undefined
}

// Reducer function
export const filterReducer = (state: FilterState, action: Action): FilterState => {
    switch (action.type) {
        case "SET_FILTER":
            const { field, op, data } = action.payload
            const existingFilterIndex = state.filters.findIndex(
                filter => filter.field === field
            )

            if (existingFilterIndex !== -1) {
                const currentFilter = state.filters[existingFilterIndex]
                const updatedData = data.length
                    ? [...new Set([...currentFilter.data, ...data])]
                    : []

                return {
                    ...state,
                    filters:
                        updatedData.length > 0
                            ? state.filters.map((filter, idx) =>
                                  idx === existingFilterIndex
                                      ? { ...filter, data: updatedData }
                                      : filter
                              )
                            : state.filters.filter(
                                  (_, idx) => idx !== existingFilterIndex
                              )
                }
            }
            return { ...state, filters: [...state.filters, { field, op, data }] }
        case "CLEAR_FILTER":
            const updatedState = state.filters.map(filter => {
                if (filter.field === action.payload.field) {
                    // Remove the specified value from the data array
                    const updatedData = filter.data.filter(
                        item => item !== action.payload.value
                    )

                    // If data array is empty after removal, keep the field with an empty data array
                    return {
                        ...filter,
                        data: updatedData
                    }
                }
                return filter
            })

            // Filter out any filters with empty data arrays
            const nonEmptyFilters = updatedState.filter(filter => filter.data.length > 0)

            // If no filters remain with data, return an empty array; otherwise, return the updated filters
            return {
                ...state,
                filters: nonEmptyFilters
            }

        case "CLEAR_ALL_FILTERS":
            return {
                ...state,
                filters: []
            }
        case "SORT_PRODUCTS":
            return { ...state, sort: action.payload }

        case "CLEAR_SORT":
            return { ...state, sort: undefined }
        case "HYDRATE_FROM_URL":
            return action.payload
        default:
            return state
    }
}
